// extracted by mini-css-extract-plugin
module.exports = {"top":"i_3","bottom":"i_4","left":"i_5","right":"i_6"};